import UISelect from 'UIComponents/input/UISelect';
import { View } from 'foundations-components/components/View';
import { CTA } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useCTAFilter } from '../../hooks/useCTAFilter';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useOperatorOptions } from '../../hooks/useOperatorOptions';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import ConditionError from '../common/ConditionError';
import EditorConditionRefinements from './EditorConditionRefinements';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import EditorRelatedConditionsRefineButton from './EditorRelatedConditionsRefineButton';
import EditorUIFieldSet from './EditorUIFieldSet';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import EditorConditionAsset from './EditorConditionAsset';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorCTARelatedConditionsGroup = props => {
  var _condition$field;
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    inputUse
  } = props;
  const {
    getFieldLabelString
  } = useTranslationHelpers(CTA);
  const {
    onRefineFilter,
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(CTA, conditionPath, condition);
  const {
    statusCondition,
    subjectVersionCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue,
    onSubjectVersionValueChange
  } = useCTAFilter(condition, onFieldConditionValueChange);
  const {
    getTrackerInstance,
    props: {
      baseFilterFamily,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const hasInPlaceRefinementSelection = !!useOnePanel;
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(CTA, statusCondition);

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.userHasNoAccess;
  const onSelectedOptionChange = evt => {
    var _getTrackerInstance, _condition$field2, _condition$field3;
    const operatorName = evt.target.value.value;
    onFieldConditionOperatorChange(getOperatorByName(operatorName));
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.name,
      type: (_condition$field3 = condition.field) === null || _condition$field3 === void 0 ? void 0 : _condition$field3.type,
      version: useOnePanel ? '2' : '1'
    });
  };
  const heading = /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(EditorUIFieldSet, {
      legend: getFieldLabelString(statusCondition.field),
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: CTA,
          inputUse: inputUse
        })
      }), /*#__PURE__*/_jsx(UISelect, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        "data-selenium-info": dataSeleniumInfo,
        "data-selenium-test": "fr-filter-operator-select",
        "data-test-id": "fr-filter-operator-select",
        disabled: userHasNoAccess,
        onSelectedOptionChange: onSelectedOptionChange,
        optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
          message: true,
          option: option
        }),
        options: operatorOptions,
        value: condition.constructor.toString()
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          inputUse: inputUse,
          condition: subjectVersionCondition,
          disabled: userHasNoAccess,
          filterFamily: CTA,
          onChange: onSubjectVersionValueChange
        })
      }), /*#__PURE__*/_jsx(ConditionError, {
        condition: condition
      }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
        condition: condition
      }), !hasInPlaceRefinementSelection && /*#__PURE__*/_jsx(EditorRelatedConditionsRefineButton, {
        dataSeleniumInfo: dataSeleniumInfo,
        disabled: userHasNoAccess,
        onClick: () => onRefineFilter(CTA, conditionPath)
      }), hasInPlaceRefinementSelection && !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
        inputUse: inputUse,
        condition: condition,
        conditionPath: conditionPath,
        filterFamily: CTA,
        onConditionChange: onFieldConditionValueChange,
        emptyRefinementConditions: refinementConditionsEmptyValue
      })]
    })
  });
  return hasInPlaceRefinementSelection ? /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: CTA,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  }) : /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: CTA,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(EditorConditionRefinements, {
      inputUse: inputUse,
      condition: condition,
      filterFamily: CTA,
      onConditionChange: onFieldConditionValueChange,
      dateRefinement: dateRefinementCondition,
      numberRefinement: numberRefinementCondition
    })
  });
};
export default EditorCTARelatedConditionsGroup;